import * as React from 'react';

function SvgCircleSignal(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={34} height={34} viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M17 .333C7.8.333.333 7.8.333 17 .333 26.2 7.8 33.667 17 33.667c9.2 0 16.666-7.467 16.666-16.667C33.666 7.8 26.2.333 17 .333zm0 30C9.633 30.333 3.666 24.367 3.666 17S9.633 3.667 17 3.667c7.366 0 13.333 5.966 13.333 13.333S24.366 30.333 17 30.333z"
        fill="#000"
      />
      <path
        d="M8.833 13.967c.433.933.65 1.933.667 3 .016 1.05-.217 2.083-.667 3.1l2.283 1.033c.617-1.35.917-2.75.9-4.167a9.673 9.673 0 00-.9-4l-2.283 1.034zm10.384-4.75c1.3 2.616 1.966 5.233 1.966 7.733 0 2.517-.666 5.15-1.966 7.817l2.25 1.1c1.466-3.017 2.216-6.017 2.216-8.917 0-2.9-.75-5.883-2.216-8.85l-2.25 1.117zM14 11.533a12.643 12.643 0 011.333 5.667c0 1.95-.433 3.717-1.3 5.25l2.167 1.233c1.083-1.916 1.633-4.083 1.633-6.483 0-2.367-.533-4.65-1.6-6.783L14 11.533z"
        fill="#5F59FF"
      />
    </svg>
  );
}

export default SvgCircleSignal;
